// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4564":"b74235c7","4901":"b74235c7"}[chunkId] + ".chunk.css";
};